import { useNavigate, Outlet } from 'react-router-dom';
import SetupPageLayout from '../../components/setup/SetupPageLayout';
import { getAdminStep } from '../../constants/setupRoadmapSteps';

const agentsStep = getAdminStep('agents');

/**
 * Layout for the Agent Management setup step.
 * Wraps SetupPageLayout and renders child routes in an Outlet.
 */
function AgentSetupLayout() {
    const navigate = useNavigate();

    return (
        <SetupPageLayout
            stepNumber={agentsStep.number}
            totalSteps={agentsStep.total}
            title={agentsStep.title}
            description="Configure and manage RAG agents and their knowledge base collections. This step is optional - you can set up agents and collections later if needed."
            onNext={() => navigate('/admin')}
            onPrevious={() => navigate('/admin/setup/network')}
            nextDisabled={false}
            nextLabel="Finish Setup"
            previousLabel="Network Connectivity"
        >
            <Outlet context={{ inSetupPortal: true }} />
        </SetupPageLayout>
    );
}

export default AgentSetupLayout;
